/** Which entity kind can supply a context for an event family.
 *
 *  Mirrors `ConsoleTestContextMixin.ENTITY_KIND_BY_FAMILY` on the backend — the
 *  entity context mode is only offered for families that can actually build one,
 *  so an event like `tour_operator.created` shows JSON / delivery-log only.
 */
import type { EntityKind } from '../notifications/test-render/ContextSourcePicker';

export const ENTITY_KIND_BY_FAMILY: Record<string, EntityKind> = {
  tour_participant: 'gtu',
  order: 'order',
  user: 'user',
};
